import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "Lenspire_Icon_CloseGlobal",
  "use": "Lenspire_Icon_CloseGlobal-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" id=\"Lenspire_Icon_CloseGlobal\">\n<path d=\"M12.414,11l9.293-9.293c0.391-0.391,0.391-1.023,0-1.414s-1.023-0.391-1.414,0L11,9.586L1.707,0.293\n\tc-0.391-0.391-1.023-0.391-1.414,0s-0.391,1.023,0,1.414L9.586,11l-9.293,9.293c-0.391,0.391-0.391,1.023,0,1.414\n\tC0.488,21.902,0.744,22,1,22s0.512-0.098,0.707-0.293L11,12.414l9.293,9.293C20.488,21.902,20.744,22,21,22s0.512-0.098,0.707-0.293\n\tc0.391-0.391,0.391-1.023,0-1.414L12.414,11z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./frontend/assets/icons/Lenspire_Icon_CloseGlobal.svg
// module id = 233
// module chunks = 0